export const helpCenterContentAdapter = (data) => {
  const createdAt = new Date(data.page.created_at);
  const modifiedAt = new Date(data.page.modified_at);

  return {
    id: data.page.id,
    caption: data.page.caption,
    description: data.page.description,
    meta_title: data.page.meta_title,
    meta_description: data.page.meta_description,
    slug: data.page.slug,
    category: data.subsection.slug,
    category_name: data.subsection.caption,
    section: data.section.slug,
    section_name: data.section.caption,
    cover: data.page.cover,
    time: data.page.reading_time,
    page_views: data.page.page_views,
    courses: data.courses.map((course) => ({
      caption: course.caption,
      slug: `/${course.section.slug}/${course.slug}`,
    })),
    body: data.page.body,
    createdAt: createdAt.toISOString(),
    modifiedAt: modifiedAt.toISOString(),
    asideNav: data.pages
      .filter((item) => item.slug.length > 0)
      .map((item) => ({
        caption: item.caption,
        slug: item.slug,
        id: item.id,
      })),
  };
};
